const regex = /^[0-9]*$/;

export const specialCharacterTest = (value) => {
  return regex.test(value);
};

export const validate2 = (name) => {
  let data = { ...name };
  let isNotValid = false;

  for (let key of Object.keys(name).filter((key) => !key.includes("Error"))) {
    if (
      name[key] === null ||
      (typeof name[key] === "string" && name[key].trim() === "")
    ) {
      data[key + "Error"] = true;
      isNotValid = true;
    } else {
      data[key + "Error"] = false;
    }
  }
  data["notValid"] = isNotValid;
  return data;
};

export const validate = (name) => {
  let data = { ...name };
  let hasError = false;
  for (let key of Object.keys(name).filter((key) => !key.includes("Error"))) {
    if (
      key === "otherInfomationEmployment" ||
      key === "extendsIn" ||
      key === "leaveAbsenceFrom" ||
      key === "leaveAbsenceEnd" ||
      key === "otherInformation" ||
      key === "amountForOverTime"
    ) {
      continue;
    }
    if (typeof name[key] === "string" && name[key].trim() === "") {
      data[key + "Error"] = true;
      hasError = true;
    } else {
      data[key + "Error"] = false;
    }
  }
  data["notValid"] = hasError;
  return data;
};

export const validateSpecificDates = (data, totalTeachingHoursSecondYear) => {
  let validationData = { ...data };
  let notValid = false;
  const specificKeys = [
    "continueWorkFromDate",
    "continueWorkEndDate",
    "isContinueEmployeeAcceptedDate",
    "salaryRefers",
    "reportedTimeFromDate",
  ];

  if (totalTeachingHoursSecondYear > 0){
    specificKeys.push('reportedTimeEndDate');
  }
  
  for (let key of specificKeys) {
    if (
      validationData[key] === null ||
      typeof validationData[key] === "undefined" ||
      (typeof validationData[key] === "string" &&
        validationData[key].trim() === "")
    ) {
      validationData[key + "Error"] = true;
      notValid = true;
    } else {
      validationData[key + "Error"] = false;
    }
  }
  validationData["notValid"] = notValid;
  return validationData;
};
